import React, { useEffect, useState } from 'react';
import {
  loadSearchAnalyticsActions,
  loadSearchActions,
  loadPipelineActions,
  loadSearchHubActions,
  buildHistoryManager,
  buildSort,
  buildFacet,
  loadFieldActions,
  SortOrder,
  buildFieldSortCriterion,
  loadAdvancedSearchQueryActions
} from '@coveo/headless';
import { headlessEngine } from '../../engine';
import { ResultList } from '../../components/result-list';
import { Facet } from '../../components/facet';
import { bindUrlManager } from '../../components/url-manager';
import { BreadcrumbManager } from '../../components/facet-breadcrumb';
import { resultTemplatesManager } from '../../controllers/result-templates-manager-system';
import * as Controllers from '../../controllers/controllers';

//const initialCriterion = criteria[0][1];
const initialCriterion = buildFieldSortCriterion(
  'systemdetailsortorder',
  SortOrder.Ascending
);
const sortController = buildSort(headlessEngine, {
  initialState: { criterion: initialCriterion }
});

function CoveoListing(props) {
  const fields = JSON.parse(props.fields);
  const localization = JSON.parse(props.localization);
  const coveoConfig = JSON.parse(props.coveo);
  const searchFields = JSON.parse(props.searchFields);
  const sortedFacets = JSON.parse(props.sortedFacets);
  const [toggleFilter, setToggleFilter] = useState(false);
  const [fieldsControllers, setFieldControllers] = useState([]);
  const [sortState, setSortState] = useState(Controllers.sortController.state);

  // Map the fields to the facet controllers
  useEffect(() => {
    setFieldControllers(
      fields.map(field => {
        field.controller = buildFacet(headlessEngine, {
          options: {
            field: field.value,
            filterFacetCount: true,
            numberOfValues: 9999,
            fieldId: field.value
          }
        });
        return field;
      })
    );
  }, []);

  // Setting up the custom properties for the search engine (Pipeline, SearchHub, fields, etc.)
  useEffect(() => {
    if (fieldsControllers.length > 0) {
      const initialCriterion = buildFieldSortCriterion(
        'systemdetailsortorder',
        SortOrder.Ascending
      );
      const { logInterfaceLoad } = loadSearchAnalyticsActions(headlessEngine);
      const { setPipeline } = loadPipelineActions(headlessEngine);
      const { executeSearch } = loadSearchActions(headlessEngine);
      const { setSearchHub } = loadSearchHubActions(headlessEngine);
      const { registerFieldsToInclude } = loadFieldActions(headlessEngine);
      const { registerAdvancedSearchQueries } =
        loadAdvancedSearchQueryActions(headlessEngine);
      headlessEngine.dispatch(
        registerAdvancedSearchQueries({
          aq: `@pagelanguage=${props.language} @fsystemtechnology=="${props.systemTechnology}"`
        })
      );
      headlessEngine.dispatch(registerFieldsToInclude(searchFields));
      headlessEngine.dispatch(setSearchHub(coveoConfig.QuerySearchHubName));
      headlessEngine.dispatch(setPipeline(coveoConfig.QuerySearchHubName));
      bindUrlManager(headlessEngine);
      headlessEngine.dispatch(executeSearch(logInterfaceLoad()));
    }
  }, [fieldsControllers]);

  useEffect(() => {
    Controllers.sortController?.subscribe(() => {
      setSortState(Controllers.sortController.state);
    });
  }, []);

  useEffect(() => {
    const initialCriterion = buildFieldSortCriterion(
      'systemdetailsortorder',
      SortOrder.Ascending
    );
    if (sortState.sortCriteria === 'relevancy') {
      Controllers.sortController.sortBy(initialCriterion);
    }
  }, [sortState]);

  const handleToggleClick = () => {
    setToggleFilter(!toggleFilter);
    if (!toggleFilter) {
      closeAllFacets();
    }
    document.body.classList.toggle('fullscreen-filters');
  };

  const closeAllFacets = filterExpanded => {
    const customEvent = new CustomEvent('coveoFacet.collapseAll');
    window.dispatchEvent(customEvent);
    const page = document.querySelector('html');

    if (filterExpanded) {
      page.classList.add('filterModalOverride');
    } else {
      page.classList.remove('filterModalOverride');
    }
  };

  return (
    <div className="coveo-search-results coveo-search-results--system">
      <div className="coveo-search-results__sidebar system-filter-row__filter-column">
        <div
          className="coveo-search-results__filters-wrapper"
          data-expand={toggleFilter}
        >
          <div
            className={`accordion filter ${
              toggleFilter ? '' : 'accordion--collapsed'
            }`}
          >
            <button
              className="system-list__toggle-filters form-select"
              id="system-list-toggle-filters"
              onClick={handleToggleClick}
              tabIndex="0"
            >
              {toggleFilter
                ? localization.hideFilters
                : localization.showFilters}
            </button>
            <div className="system-list__filter-wrapper">
              <BreadcrumbManager
                controller={Controllers.facetBreadcrumb}
                labels={localization}
              />
              {fieldsControllers.map((field, index) => (
                <Facet
                  key={index}
                  index={index}
                  controller={field.controller}
                  title={field.label}
                  labels={localization}
                  sortedFacets={sortedFacets[field.value]}
                  numberOfValues={999}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="coveo-search-results__main">
        <ResultList
          additionalClasses="system-list__grid"
          controller={Controllers.resultList}
          resultTemplatesManager={resultTemplatesManager}
          labels={localization}
        />
      </div>
    </div>
  );
}

export default CoveoListing;
